import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ServiceCategoryModel } from '../../../../../../store/self-diagnostic/service-catalog/model';

@Component({
  selector: 'dialog-update-category',
  templateUrl: './dialog-update-category.component.html',
  styleUrls: ['./dialog-update-category.component.scss'],
  standalone: false,
})
export class DialogUpdateCategoryComponent implements OnInit {
  translate = inject(TranslateService);

  private _eventChange$: Observable<ServiceCategoryModel>;
  private _eventChangeObserver: Observer<ServiceCategoryModel>;

  public showDialog: boolean = false;

  constructor() {
    this._eventChange$ = new Observable<ServiceCategoryModel>(observer => (this._eventChangeObserver = observer));
  }

  public ngOnInit() {}

  public category: ServiceCategoryModel;

  public show(category: ServiceCategoryModel): Observable<ServiceCategoryModel> {
    this.showDialog = true;

    this.category = { ...category };

    return this._eventChange$;
  }

  public onSave() {
    if (this.category) {
      this._eventChangeObserver.next(this.category);
      this.showDialog = false;
    }
  }

  public onCancel() {
    this._eventChangeObserver.next(null);
    this.showDialog = false;
  }
}
